import {  Image, Layout } from "antd";
import React from 'react';
import { Images } from "../../../controller/Images";
import { getCandidateLogo } from "../../../controller/localStroageHandler";
const {Header,Content}=Layout
const NotValidURl = () => {
    const logo=getCandidateLogo()
  return(
    <Layout className='w-100 h-100'>
      <Header className='bg-white border-2 border-bottom border-color h-auto pt-2 pb-2'>
        {/* <Image src={logo} alt='' preview={false} /> */}
      </Header>
      <Content className='h-100 w-100 background-image d-flex justify-content-center align-items-center'>
        <div className='text-center d-flex flex-column justify-content-center align-items-center'>
          <Image src={Images?.wrongUrl} alt="" width={150} height={150} preview={false}/>
          <span className="fs-3 fw-medium">Check you Email For the Valid Url</span>
        </div>
      </Content>
    </Layout>
  )
};

export default NotValidURl;
